<template>
    <v-content>
        <v-breadcrumbs :items="snackbar.breadcrumbsItems" large></v-breadcrumbs>
        <v-row>
            <v-col
                cols="12"
                sm="4"
                md="3"
                xl="2"
                    v-for="title in snackbar.dashboardItems"
                    v-bind:key="title.link"
                    class="viewCard"
            >
                <router-link :to="`/branchList/${title.id}`" v-if="title.count">
                    <v-card
                            :elevation="10"
                            class="teal darken-1 text-center"
                            height="150"
                            width="300"
                    >
                        <v-list-item three-line link>
                            <v-list-item-content>
                                <v-list-item-title
                                        class="white--text subtitle-1 mt-1 pa-4"
                                >
                                    <div>
                                        <span>{{title.name}}</span>
                                    </div>
                                    <div>
                                        <span>Total Branch : {{title.count}}</span>
                                    </div>

                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-card>
                </router-link>
                    <v-card v-else
                            :elevation="10"
                            class="teal darken-3 text-center"
                            height="150"
                            width="300"
                    >
                        <v-list-item three-line>
                            <v-list-item-content>
                                <v-list-item-title
                                        class="white--text subtitle-1 mt-1 pa-4"
                                >
                                    <div>
                                        <span>{{title.departmentName}}</span>
                                    </div>
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-card>
            </v-col>
        </v-row>
    </v-content>
</template>

<script>
    /*import CompanyDashboardMenu from "./CompanyDashboardMenu";*/
    import axios from "axios";
    import {mapGetters} from "vuex";

    export default {
        name: "DepartmentDashboard",
        computed:{
            ...mapGetters({
                userRole: 'getUserRole',
                usersData: 'getUserData',
            }),
        },
        data() {
            return {
                snackbar: {
                    formModal: false,
                    color: '',
                    snackbar: false,
                    text: '',
                    timeout: 6000,
                    drawer: null,
                    drawerRight: null,
                    right: false,
                    dashboardItems: [],
                    breadcrumbsItems: []
                },
                customerData: {
                    updateItem: {}
                },
                branchInformation: [],
            }
        },
        methods: {
            clickEvent(route) {
                this.$router.push({name: route})
            },
            addFormModal(route) {
                this.snackbar.formModal = true
                this.dynamicComponent.current = route
            },
            dialogueClose() {
                this.customerData.updateItem = {}
                this.snackbar.formModal = false
            },
            formResponse(responseObj) {
                this.snackbar.color = responseObj.status ? 'success' : 'red'
                this.snackbar.text = responseObj.text
                this.snackbar.snackbar = true
            },
            openDrawer() {
                this.snackbar.drawerRight = !this.snackbar.drawerRight
            },
            async dashboardData() {
                this.snackbar.breadcrumbsItems=[
                    {
                        text: "Dashboard",
                        disabled: false,
                        to: this.usersData.dashBoard,
                        exact: true
                    },
                    {
                        text: "Provisional offices",
                        disabled: true,
                        to: "/CompanyList",
                        exact: true
                    },
                ]
                axios.post("Department/GetDepartmentTiles", {companyID: parseInt(this.$store.getters.getUserData.companyID)}).then(response => {
                    this.snackbar.dashboardItems = response.data
                })
            }
        },
        mounted() {
            this.dashboardData()
        },
        components: {
            /* 'menu-list': CompanyDashboardMenu,*/
            /*// eslint-disable-next-line vue/no-unused-components
            'CompanyForm': () => import(/!* webpackChunkName: "CompanyForm" *!/ '../company/airDestination/CompanyForm'),
            // eslint-disable-next-line vue/no-unused-components
            'SectionsForm': () => import(/!* webpackChunkName: "SectionsForm" *!/ '../company/Sections/SectionsForm'),
            // eslint-disable-next-line vue/no-unused-components
            'PeriodicBudgetForm': () => import(/!* webpackChunkName: "PeriodicBudgetForm" *!/ '../company/PeriodicBudget/PeriodicBudgetForm'),
            // eslint-disable-next-line vue/no-unused-components
            'CustomerForm': () => import(/!* webpackChunkName: "CustomerForm" *!/ '../company/customer/CustomerForm')*/
        }
    }
</script>

<style scoped lang="scss">
    .options {
        border: 2px solid white;
    }

</style>
